<template>
  <div class="app-wrapper">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  // mounted() {
  //   setTimeout(
  //     (() => {
  //       this.$store.dispatch("set_popup", parseInt(2, 10));
  //     }).bind(this),
  //     2000
  //   );
  // },
};
</script>

<style lang="scss">
@import "./assets/styles/app.scss";
</style>
